import { Center, Spinner } from '@chakra-ui/react';

export const Loader = () => {
  return (
    <Center flex="1" backgroundColor={'transparent'}>
      <Spinner />
    </Center>
  );
};
